import { useQuery } from '@tanstack/react-query';
import * as api from '../api/mail.api';

export const useUnifiedInbox = (params = {}) => {
    const key = ['mail','unified', JSON.stringify(params)];
    return useQuery({ queryKey: key, queryFn: () => api.fetchUnifiedInbox(params), keepPreviousData: true });
};
